export const chartColorsArray = [
  '#007AFF',
  '#FF9500',
  '#FF3B30',
  '#34C759',
  '#AF52DE',
  '#5AC8FA',
  '#FF2D55',
  '#FFCC00',
  '#5856D6',
  '#00C7BE',
  '#A2845E',
  '#FFD60A',
];